export default {
  localFunctions: false,
  localFirestore: false,
  localAuth: false,
  localStorage: false,
  local: false,
  dev: false,
  prod: true,
  contentfulEnvironment: 'master',
  contentfulWebsiteEntryId: '20shcpmbQorh1bx6b138IY',
  appBaseUrl: 'https://app.trademailer.co.uk',
  bucketBaseUrl: 'https://firebasestorage.googleapis.com/v0/b/leadgen-server-prod.appspot.com/o/',
  firebaseConfig: {
    apiKey: 'AIzaSyCBmmPPBy23O04TreQ1I2iyqnn1wtkuAlo',
    authDomain: 'leadgen-server-prod.firebaseapp.com',
    projectId: 'leadgen-server-prod',
    storageBucket: 'leadgen-server-prod.appspot.com',
    messagingSenderId: '641643929405',
    appId: '1:641643929405:web:7a1b424dda3ca32c112f54',
    measurementId: 'G-5DMMJ9RKJQ',
  },
  metaPixelId: '2467126067048305',
  cookiebotDomainGroupId: '8900de47-7e26-4dbe-94be-dc49146e60eb',
  imgixBaseUrl: 'https://trade-mailer-prod.imgix.net/',
  stripeSecret:
    'pk_live_51OpA9rL2l4kVgcuS0bDDlHiQB4zSt2YAExuC5jINBgXOTVdALtz2hPHtZsedz8n0MkX2ZBOq1vE1aLjsDdpQk40G00yFQhPlbj',
  idealPostcodesApiKey: 'ak_mloa5m5hXQclhcBKAfsZ3V5ZjwXcP',
  polotnoApiKey: 'Pw61VRNK3Ub2BYw6Tvyw',
  whatsappUrl: 'https://wa.me/447984464429',
}
